var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { P, CustomElement, Components } from '@pacem/pacem-core';
//namespace Pacem.Components.UI {
let PacemSlideElement = class PacemSlideElement extends Components.PacemIterableElement {
};
PacemSlideElement = __decorate([
    CustomElement({
        tagName: P + '-slide'
    })
], PacemSlideElement);
export { PacemSlideElement };
let PacemSlideshowElement = class PacemSlideshowElement extends Components.PacemIterativeElement {
    validate(item) {
        return item instanceof PacemSlideElement;
    }
};
PacemSlideshowElement = __decorate([
    CustomElement({
        tagName: P + '-slideshow'
    })
], PacemSlideshowElement);
export { PacemSlideshowElement };
